import { lazy } from 'react';

import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

const DashboardDefault = Loadable(lazy(() => import('adminViews/Dashboard')));
const VisitorManagement = Loadable(lazy(() => import('views/Visitor')));
const AppointmentManagement = Loadable(lazy(() => import('views/Appointment')));
const PassesManagement = Loadable(lazy(() => import('views/Passes')));
const Calender = Loadable(lazy(() => import('views/Calender')));
const UserManagement = Loadable(lazy(() => import('views/User')));
const CompanyManagement = Loadable(lazy(() => import('adminViews/Company')));
const ReportManagement = Loadable(lazy(() => import('adminViews/Report')));
const PaymentHistory = Loadable(lazy(() => import('adminViews/PaymentHistory')));
const Configure = Loadable(lazy(() => import('views/Configure')))
const AllEntry = Loadable(lazy(() => import('views/AllEntry')))
const EntriesManagemenmt = Loadable(lazy(() => import('views/Entries')))
const ViewUserDetails = Loadable(lazy(() => import('views/User/ViewUserDetails')))
const ViewVisitorDetails = Loadable(lazy(() => import('views/Visitor/ViewVisitorDetails')))
const ViewCompanyDetails = Loadable(lazy(() => import('adminViews/Company/ViewCompanyDetails')))
const SubscriptionManagement = Loadable(lazy(() => import('adminViews/Subscription')))

const AdminRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: '/',
            element: <DashboardDefault />
        },
        {
            path: '/*',
            element: <DashboardDefault />
        },
        {
            path: 'dashboard',
            children: [
                {
                    path: 'default',
                    element: <DashboardDefault />
                },
                {
                    path: 'company',
                    element: <CompanyManagement />
                },
                {
                    path: 'company/fulldetails/:userid',
                    element: <ViewCompanyDetails />
                },
                {
                    path: 'subscription',
                    element: <SubscriptionManagement />
                },
                {
                    path: 'paymenthistory',
                    element: <PaymentHistory />
                },
                {
                    path: 'report',
                    element: <ReportManagement />
                },
                {
                    path: 'profile',
                    element: <Configure />
                },
                {
                    path: '*',
                    element: <DashboardDefault />
                }
            ]
        }
    ]
};

export default AdminRoutes;
